let viewTemplate = require('templates/customers/modal-quick-view.hbs');
let Promise = require('bluebird');
let modal = require('../helpers/modal');

exports.fastCustomer = (customer) => new Promise( (resolve, reject) => {

    let options = {
        title: `Informações do Cliente`,
        body: `<div class="text-center">Carregando... <img src="/assets/images/preloader.gif" /></div>`,
        width: 600,
        primaryButton: false
    };

    if (customer.editable) {
        options.primaryButton = `Ver cadastro completo`
        options.secondaryButton = `Fechar`
        options.onPrimaryButton = function ($modal) {
            location.href = `/customers/${customer.id}/editor`
        }
    }

    let $modal = modal(options);

    $modal.trigger('modal.body-changed', viewTemplate(customer));
    resolve()
})


// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/ui/property-customer.js